import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const TabsContainer = styled.div<{ haveTitle?: boolean }>`
  list-style: none;
  overflow-x: auto;
  padding: 0;
  margin: 0;
  padding-left: 24px;
  display: flex;
  align-items: center;
  gap: 8px; /* Default gap for mobile and tablet */
  margin-top: 16px;
  margin-bottom: 32px;

  @media (min-width: ${breakpoints.desktop}) {
    justify-content: center;
    margin-top: 24px;
    gap: 16px; /* Override gap for desktop */
  }

  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
`;

export const Tab = styled.div<{ selected: boolean }>`
  margin: 0;
  border: 1px solid ${colors.$262626};
  border-radius: 20px;
  font-family: ${fonts.regular};
  font-weight: 400;
  ${pxToCssFont(16, 22)}
  padding: 3px 12px;
  flex-shrink: 0;
  height: 32px; /* Default height for mobile and tablet */
  color: ${({ selected }) => (selected ? colors.$ffffff : colors.$0d0d0d)};
  background-color: ${({ selected }) => (selected ? colors.$262626 : colors.$ffffff)};

  &:hover {
    cursor: pointer;
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding: 4px 16px;
    height: 30px; /* Override height for desktop */
  }
`;

